import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type { TopUpCredit, TopUpCreditRequestPayload } from './types';

const topUpCreditRequest = async (
  payload: TopUpCreditRequestPayload
): Promise<TopUpCredit> => {
  const res = await axios<
    TopUpCredit,
    BaseResponse<TopUpCredit>,
    TopUpCreditRequestPayload
  >({
    url: `/glfh/top-up/crediting-of-top-up`,
    method: 'post',
    data: {
      ...payload,
    },
  });

  return res?.data?.data;
};

export const useTopUpCreditRequest = () => {
  const { mutateAsync, data, isLoading, error } =
    useMutation(topUpCreditRequest);

  useEffect(() => {
    displayError(error);
  }, [error]);

  return { topUpCreditRequest: mutateAsync, data, isLoading };
};
